// src/api/mock/accountTypeData.js

export const accountTypeMockData = [
  { id: "doctor", name: "Doctor" },
  { id: "nurse", name: "Nurse" },
  { id: "pharmacist", name: "Pharmacist" },
  { id: "dentist", name: "Dentist" },
  { id: "other", name: "Other Healthcare Professional" },
];